import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { uploadSelfie } from "../../services/auth.service";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../slice/commonSlice";
import { toast } from "react-toastify";
import { FileUploadIcon } from "../../components/Icons";
import { toast_error, toast_success } from "../../config/Constant";
import { jobId } from "../../slice/commonSlice";

const StartSelfieModal = (props) => {
  const dispatch = useDispatch();
  const [selfie, setSelfie] = useState(null);
  const jobID = useSelector(jobId);

  // Use state to track current tracking status
  const [currentStatus, setCurrentStatus] = useState(props?.details?.trackingStatus);

  // Ensure status updates when props change
  useEffect(() => {
    setCurrentStatus(props?.details?.trackingStatus);
  }, [props?.details?.trackingStatus]);

  // Map trackingStatus to file type
  const fileTypeMap = {
    null: "startSelfie",
    otw: "inTransitSelfie",
    inTransit: "endSelfie",
  };

  // Define the next status
  const nextStatusMap = {
    null: "otw",
    otw: "inTransit",
    inTransit: "delivered",
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error("Please select a file.", toast_error);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => setSelfie(e.target.result);
    reader.readAsDataURL(file);

    uploadSelfieFile(fileTypeMap[currentStatus] || "startSelfie", file);
  };

  const uploadSelfieFile = async (fileType, file) => {


    const formData = new FormData();
    formData.append(fileType, file);
    formData.append("jobId", props?.details?._id);

    dispatch(setLoader(true));

    try {
      const response = await uploadSelfie(formData);
      dispatch(setLoader(false));

      if (response?.status) {
        toast.success(response?.data?.message, toast_success);

        // Update state and parent component
        const updatedStatus = nextStatusMap[currentStatus];
        setCurrentStatus(updatedStatus);
        // props.setSelectedStatus(updatedStatus);
        // props.updateStatus(updatedStatus);
        props.handleStartSelfieClose();
      } else {
        toast.error("No image found", toast_error);
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error);
      dispatch(setLoader(false));
      console.error("Upload Error:", error);
    }
  };

  return (
    <Modal
      show={props.startSelfieModal}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={props.handleStartSelfieClose}
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="start-end-selfie">
          <h5>
            {currentStatus === null && "Please upload job start photo first"}
            {currentStatus === "otw" && "Please upload in-transit start photo"}
            {currentStatus === "inTransit" && "Please upload job delivered photo"}
          </h5>
        </div>
        <div className="job-content-section">
          <div className="box-wrapper browse">
            <FileUploadIcon />
            <div>Upload Photo</div>
            <Button variant="outline-primary">
              Browse
              <input type="file" name="profilePic" onChange={onFileChange} />
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StartSelfieModal;
